import { Button } from '@mui/material';
import React from 'react';
import { persistStore } from 'redux-persist';
import { store } from 'store';

export const clearReduxPersist = () => {
  const persistor = persistStore(store);
  try {
    persistor.purge();
    window.location.href = '/';
    console.log('Local Storage Cleared');
  } catch (error) {
    console.log('Error clearing local storage: ', error);
  }
};

export default function ClearReduxPersistStore() {
  return (
    <Button fullWidth onClick={() => clearReduxPersist()} variant="outlined" color="primary">
      Clear Local Storage
    </Button>
  );
}
